import app from "assets/app.json";
import localConfig from "assets/configs/config.local.theme.default.json";
import blackThemConfig from "assets/configs/config.local.theme.black.json";
import bootstrapThemConfig from "assets/configs/config.local.theme.bootstrap.json";


import { __callbacks } from "../Callbacks/Callback";
import { __debug } from "../Debug/Debug";
import {__ajax} from "../AJAX/ajax";


class Config {
    
    remoteUrl = app.config.remote.url;
    config: any = {};
    configType = "local";
    configStatus = "in-progress";
    configChatKey = "";
    configTimer!: NodeJS.Timeout;
    maxRemoteFetchTime = 10000;    //3000ms = 3 sesonds
    subscribe: Function = (callback: Function) => {
        if (this.configStatus === "finished") return callback(this.getCallbackData());
        __callbacks.config.register(callback);
    }

    constructor() {
        this.initLocalConfig();
        this.initAppConfigRemote();
        this.handleLateResponse();
    }

    /**
     * initializes the local configuration
     * @returns {void} returns nothing
     */
    initLocalConfig = (): void => {
        this.config = localConfig;
    }
    setBlackThemeConfig = () => {
        this.config = blackThemConfig;
    }
    setBootstrapThemConfig = () => {
        this.config = bootstrapThemConfig;
    }
    
    /**
     * initializes the app configuration
     * @returns {void} returns nothing
     */
    initAppConfigRemote = async () => {
        this.setStatusInProgress();
        this.setRemoteConfig();
        await this.fetchRemoteConfig();
    }
    /**
     * fetches the configuration from the remote url
     * @returns {void} returns nothing
     */
    fetchRemoteConfig = () => {

        const queryParams = new URLSearchParams(window.location.search);
        const uid = queryParams.get('chatCode'); // Assuming chatCode is the unique identifier for the chat
        const domain = queryParams.get('url'); // This is the parent URL where the widget is installed

        const jsonData = {
            uid: uid,
            domain: domain
        };

         __ajax.sendAjaxRequest('post', '/chat/load', JSON.stringify(jsonData), (res: any) => {
             this.handleResponse(res);
            return res
        });
    }
    /**
     * handles the response returned from the remote url.
     * @returns {void} returns nothing
     */
    handleResponse = (res: any) => {
        
            try {
                const config = res;
                this.config = config;
                this.onFinishFetchRemote();
            } catch (err) {
                this.finishFetchLocal();
            __debug.warn(() => {
                console.warn(`Invalid JSON Confugration! Got Invalid json in response from [${this.remoteUrl}]`);
            });
            }
        }
        
    /**
     * handles the late response from the remote url.
     * @returns {void} returns nothing
     */
    handleLateResponse = () => {
        this.configTimer = setTimeout(() => {
            // too late to fetch settings from the remote url
            // revert back to local settings
            this.finishFetchLocal();
            __debug.warn(() => {
                console.warn("too late to fetch settings from the remote url");
            });
        }, this.maxRemoteFetchTime);
    }

    /**
     * returns configuration object
     * @returns {object} cofiguration object
     */
    getAppConfig = () => {
        return this.config;
    }
    setStatusInProgress = () => {
        this.configStatus = "in-progress";
    }
    setStatusFinished = () => {
        this.configStatus = "finished";
    }
    setLocalConfig = () => {
        this.configType = "local";
    }
    setRemoteConfig = () => {
        this.configType = "remote";
    }

    setChatKey = (key: string ) => {
        this.configChatKey = key;
    }

    getChatKey = () => {
        return window.parent.postMessage({
            'func': 'getKey',
            'message': ''
        }, "*");
    }
    /**
     * returns callback data
     * @returns {object} callback data
     */
    getCallbackData = () => {
        return {
            status: this.configStatus,
            config: this.config,
            configType: this.configType
        };
    }
    /**
     * setups the configuration mode to local 
     * and calls (finished) callback
     * @returns {void} returns nothing
     */
    finishFetchLocal = () => {
        clearTimeout(this.configTimer);
        this.setStatusFinished();
        this.setLocalConfig();
        __callbacks.config.trigger(this.getCallbackData());
        this.initDevLog();
    }
    /**
     * setups the configuration mode to remote 
     * and calls (finished) callback
     * @returns {void} returns nothing
     */
    onFinishFetchRemote = () => {
        clearTimeout(this.configTimer);
        this.setStatusFinished();
        this.setRemoteConfig();
        __callbacks.config.trigger(this.getCallbackData());
        this.initDevLog();

        window.parent.postMessage({
            'func': 'configFinish',
            'message': __config
        }, "*");
    }
    /**
     * initializes the black theme configurations
     */
    initBlackThemeConfig = () => {
        this.subscribe((config: any) => {
            if (config.status !== "finished") return;

            clearTimeout(this.configTimer);
            this.setBlackThemeConfig();
            this.setStatusFinished();
            this.setLocalConfig();
            __callbacks.config.trigger(this.getCallbackData());
            this.initDevLog();

          });
    }
    /**
     * initializes the boostrap theme configurations
     */
     initBootstrapThemeConfig = () => {
        this.subscribe((config: any) => {
            if (config.status !== "finished") return;

            clearTimeout(this.configTimer);
            this.setBootstrapThemConfig();
            this.setStatusFinished();
            this.setLocalConfig();
            __callbacks.config.trigger(this.getCallbackData());
            this.initDevLog();

          });
    }
    /**
     * show the configuration log history in the browser dev log
     * @returns {void} returns nothing
     */
    initDevLog = () => {
        if (this.configType === "local") {
            //console.warn(`Using Local Configurations.`);
        }
        else {
            //console.log(`Using Remote Configurations.`);
        }
    }
}

// export Config class instance (singleton)
export const __config = new Config();